import { useState } from 'react';

/** Área de envio de arquivo (clique ou arrastar). */
export default function FileDrop({ onFile, accept = 'application/pdf,image/*', title = 'Selecionar arquivo', description = 'PDF ou imagem, até 10 MB', file }: {
  onFile: (f: File) => void;
  accept?: string;
  title?: string;
  description?: string;
  file?: File | null;
}) {
  const [over, setOver] = useState(false);
  return (
    <label
      className={`drop ${over ? 'over' : ''}`}
      onDragOver={(e) => { e.preventDefault(); setOver(true); }}
      onDragLeave={() => setOver(false)}
      onDrop={(e) => { e.preventDefault(); setOver(false); const f = e.dataTransfer.files[0]; if (f) onFile(f); }}
    >
      <input type="file" accept={accept} className="sr-only" onChange={(e) => { const f = e.target.files?.[0]; if (f) onFile(f); }} />
      <div className="t">{file ? `📎 ${file.name}` : `⬆️ ${title}`}</div>
      <div className="d">{file ? 'Clique para trocar' : description}</div>
    </label>
  );
}
